import React from 'react';

// Summary KPI tile. Props: label, value, icon (MUI component), accent (CSS color), sub.
export default function StatTile({ label, value, icon: Icon, accent, sub }) {
  return (
    <div className="stat-tile" style={accent ? { '--tile-accent': accent } : undefined}>
      <div className="stat-tile-head">
        {Icon ? <Icon /> : null}
        <span>{label}</span>
      </div>
      <div className="stat-tile-value">{value}</div>
      {sub ? <div className="stat-tile-sub">{sub}</div> : null}
    </div>
  );
}
